import { UploadIcon } from '@repo/atomic-components';

interface DragAndDropOverlayProps {
  isVisible: boolean;
  fullScreen?: boolean;
  className?: string;
  message?: string;
}

export const DragAndDropOverlay = ({
  isVisible,
  fullScreen = true,
  className,
  message = 'Drop files here to add them to the chat.',
}: DragAndDropOverlayProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`${fullScreen ? 'fixed' : 'absolute'} inset-0 z-50 flex items-center justify-center bg-[hsla(155,33.3%,92.9%,0.95)] ${className}`}
    >
      <div className="flex w-55 flex-col items-center gap-6">
        <UploadIcon className="text-theme-dark-green h-[64px] w-[64px]" />
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-theme-dark-green text-2xl font-semibold">Upload files</h2>
          <p className="text-center text-base text-gray-600">{message}</p>
        </div>
      </div>
    </div>
  );
};
